export const IncomeEnum = {
  Monthly: 0,
  Weekly: 1,
  Every_Two_Weeks: 2,
  Twice_Per_Month: 3,
  Annual: 4,
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/IncomeEnum.js